import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-stack mb-4" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  for: "selectClub",
  class: "me-4 fw-bolder d-none"
}
const _hoisted_5 = { class: "options" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-clockwise fs-3 text-white" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-send-plus fs-3 text-white" }, null, -1)
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = { class: "col-xl-5" }
const _hoisted_10 = { class: "d-flex flex-wrap" }
const _hoisted_11 = { class: "col-xl-7" }
const _hoisted_12 = { class: "d-flex flex-wrap justify-content-end" }
const _hoisted_13 = { class: "card bg-transparent mb-4" }
const _hoisted_14 = { class: "card-header px-0" }
const _hoisted_15 = { class: "card-title" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" }, null, -1)
const _hoisted_17 = { class: "card-toolbar" }
const _hoisted_18 = { class: "fw-bold me-2" }
const _hoisted_19 = {
  class: "",
  style: {"line-height":"1.25"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-30 symbol-light-success me-3" }, null, -1)
const _hoisted_23 = {
  class: "text-dark-50 text-hover-primary cursor-pointer",
  style: {"line-height":"1.25"}
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_26 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_27 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-5 d-none" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }),
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_MixedWidget15 = _resolveComponent("MixedWidget15")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_ModalSearch = _resolveComponent("ModalSearch")!
  const _component_ModalPerfil = _resolveComponent("ModalPerfil")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.accountInfo?.idperfil == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("label", _hoisted_4, _toDisplayString(), 1),
              (_ctx.accountInfo?.idperfil == 1)
                ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 0,
                    id: "selectClub",
                    modelValue: _ctx.selectClub,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectClub) = $event)),
                    filterable: "",
                    class: "w-400px me-4",
                    onChange: _ctx.geDataPayroll,
                    placeholder: _ctx.t('seleccione') + _ctx.t('institution')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listClubs, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `lst-pky-${index}`,
                          label: `(${item.abrev}) - ${item?.name}`,
                          value: item.idinstitution
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange", "placeholder"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.checkAll,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkAll) = $event)),
                label: _ctx.t('all'),
                size: "large",
                onChange: _ctx.changeAll
              }, null, 8, ["modelValue", "label", "onChange"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_tooltip, {
          effect: "dark",
          content: _ctx.t('updateInformation'),
          placement: "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _ctx.geDataPayroll,
              type: "info"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["content"]),
        _createVNode(_component_el_tooltip, {
          effect: "dark",
          content: _ctx.t('sendInformation'),
          placement: "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _ctx.sendDataValidation,
              type: "success"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["content"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.openModalSearch
        }, {
          default: _withCtx(() => [
            _createTextVNode(" + " + _toDisplayString(_ctx.t("add")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_MixedWidget15, {
            "widget-classes": "bg-primary text-white rounded min-w-125px py-1 px-4 m-2",
            icon: "bi bi-graph-up-arrow text-white",
            title: _ctx.listPayroll.length,
            "sub-title": "Total"
          }, null, 8, ["title"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resGender, (item, index) => {
            return (_openBlock(), _createBlock(_component_MixedWidget15, {
              key: `itm-rsg-${index}`,
              "widget-classes": item.class,
              icon: item.icon,
              title: item.total,
              "sub-title": item.name
            }, null, 8, ["widget-classes", "icon", "title", "sub-title"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resChecks, (item, index) => {
            return (_openBlock(), _createBlock(_component_MixedWidget15, {
              key: index,
              "widget-classes": item.class,
              icon: item.icon,
              title: item.total,
              "sub-title": item.name
            }, null, 8, ["widget-classes", "icon", "title", "sub-title"]))
          }), 128))
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.textSearch,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.textSearch) = $event)),
            class: "w-300px",
            placeholder: `${_ctx.t('search')}`,
            clearable: "",
            onKeypress: _withKeys(_ctx.geDataPayroll, ["enter"]),
            onClear: _ctx.geDataPayroll
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.geDataPayroll
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "onKeypress", "onClear"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t('state')), 1),
          _createVNode(_component_el_select, {
            modelValue: _ctx.selectStatus,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectStatus) = $event)),
            multiple: "",
            "collapse-tags": "",
            "collapse-tags-tooltip": "",
            placeholder: "Filtrar por estado",
            class: "w-100 w-md-300px",
            onChange: _ctx.geDataPayroll
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: `lst-pky-${index}`,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.listPayroll,
      border: "",
      "table-layout": 'auto',
      "scrollbar-always-on": true,
      onSelectionChange: _ctx.handleSelectionChange,
      height: `${_ctx.altura <= 500 ? 500 : (_ctx.altura - 510)}px`,
      "highlight-current-row": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          width: "35",
          type: "selection"
        }),
        _createVNode(_component_el_table_column, {
          prop: "idperson",
          label: "ID",
          width: "100",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "docnumber",
          label: _ctx.t('document'),
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", null, _toDisplayString(row.docname), 1),
              _hoisted_20,
              _createElementVNode("span", null, _toDisplayString(row.docnumber), 1)
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "persona",
          label: _ctx.t('participant'),
          sortable: ""
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", null, _toDisplayString(row.firstname), 1),
                _hoisted_24,
                _createElementVNode("span", null, _toDisplayString(row.lastname + ' ' + row.surname), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "gender",
          label: _ctx.t('gender'),
          width: "100",
          align: "center",
          sortable: ""
        }, {
          default: _withCtx(({ row }) => [
            (row.gender == 'M')
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(row.gender), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(row.gender), 1))
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "birthday",
          label: _ctx.t('birthday'),
          width: "150",
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.moment(row.birthday).format("DD/MM/YYYY")), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.t('state'),
          width: "120",
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", {
              class: _normalizeClass('badge badge-' + row.status_class)
            }, _toDisplayString(row.status_name), 3)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: _ctx.t('registered'),
          width: "180",
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.moment(row.created_at).format("DD/MM/YYYY H:mm:ss")), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: _ctx.t('options'),
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            (row.check == 0 || row.check == 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: _ctx.t('edit'),
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: "bi bi-pencil-square fs-2 text-hover-primary me-4",
                        onClick: ($event: any) => (_ctx.onEdit(row, 2))
                      }, null, 8, _hoisted_28)
                    ]),
                    _: 2
                  }, 1032, ["content"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: _ctx.t('moreDetails'),
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: "bi bi-zoom-in fs-2 text-hover-primary me-4 cursor-pointer",
                        onClick: ($event: any) => (_ctx.onEdit(row, 3))
                      }, null, 8, _hoisted_30)
                    ]),
                    _: 2
                  }, 1032, ["content"]),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: _ctx.t('delete'),
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: "bi bi-trash fs-2 text-hover-danger me-4 cursor-pointer",
                        onClick: ($event: any) => (_ctx.onDelete(row))
                      }, null, 8, _hoisted_31)
                    ]),
                    _: 2
                  }, 1032, ["content"])
                ]))
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data", "onSelectionChange", "height"])), [
      [_directive_loading, _ctx.loading]
    ]),
    _hoisted_32,
    _createVNode(_component_ModalSearch, {
      ref: "ModalSearchRef",
      idinstitution: _ctx.selectClub,
      onOnResponse: _ctx.onResponse
    }, null, 8, ["idinstitution", "onOnResponse"]),
    _createVNode(_component_ModalPerfil, {
      onOnResponseMdPerfil: _ctx.onResponseMdPerfil,
      action: _ctx.action,
      status: _ctx.listStatus,
      idinstitution: _ctx.selectClub
    }, null, 8, ["onOnResponseMdPerfil", "action", "status", "idinstitution"])
  ], 64))
}